// source: src/common/orchard/group.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var src_common_orchard_system_role_pb = require('../../../src/common/orchard/system_role_pb.js');
goog.object.extend(proto, src_common_orchard_system_role_pb);
var src_common_orchard_crm_role_pb = require('../../../src/common/orchard/crm_role_pb.js');
goog.object.extend(proto, src_common_orchard_crm_role_pb);
goog.exportSymbol('proto.loupe.common.orchard.Group', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.orchard.Group = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.orchard.Group.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.orchard.Group, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.orchard.Group.displayName = 'proto.loupe.common.orchard.Group';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.orchard.Group.repeatedFields_ = [6,7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.orchard.Group.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.orchard.Group.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.orchard.Group} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.orchard.Group.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tenantId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    roleIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    rolesList: jspb.Message.toObjectList(msg.getRolesList(),
    src_common_orchard_system_role_pb.SystemRole.toObject, includeInstance),
    crmRoleIdsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    crmRolesList: jspb.Message.toObjectList(msg.getCrmRolesList(),
    src_common_orchard_crm_role_pb.CRMRole.toObject, includeInstance),
    parentId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    groupPath: jspb.Message.getFieldWithDefault(msg, 11, ""),
    order: jspb.Message.getFieldWithDefault(msg, 12, 0),
    syncFilter: jspb.Message.getFieldWithDefault(msg, 13, ""),
    opportunityFilter: jspb.Message.getFieldWithDefault(msg, 14, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdBy: jspb.Message.getFieldWithDefault(msg, 16, ""),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedBy: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.orchard.Group}
 */
proto.loupe.common.orchard.Group.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.orchard.Group;
  return proto.loupe.common.orchard.Group.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.orchard.Group} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.orchard.Group}
 */
proto.loupe.common.orchard.Group.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.loupe.common.orchard.SystemRoleType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {!proto.loupe.common.orchard.BasicStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addRoleIds(value);
      break;
    case 7:
      var value = new src_common_orchard_system_role_pb.SystemRole;
      reader.readMessage(value,src_common_orchard_system_role_pb.SystemRole.deserializeBinaryFromReader);
      msg.addRoles(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addCrmRoleIds(value);
      break;
    case 9:
      var value = new src_common_orchard_crm_role_pb.CRMRole;
      reader.readMessage(value,src_common_orchard_crm_role_pb.CRMRole.deserializeBinaryFromReader);
      msg.addCrmRoles(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupPath(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSyncFilter(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpportunityFilter(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedBy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.orchard.Group.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.orchard.Group.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.orchard.Group} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.orchard.Group.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getRoleIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      src_common_orchard_system_role_pb.SystemRole.serializeBinaryToWriter
    );
  }
  f = message.getCrmRoleIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getCrmRolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      src_common_orchard_crm_role_pb.CRMRole.serializeBinaryToWriter
    );
  }
  f = message.getParentId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getGroupPath();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getSyncFilter();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOpportunityFilter();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedBy();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loupe.common.orchard.Group.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tenant_id = 2;
 * @return {string}
 */
proto.loupe.common.orchard.Group.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.loupe.common.orchard.Group.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional SystemRoleType type = 4;
 * @return {!proto.loupe.common.orchard.SystemRoleType}
 */
proto.loupe.common.orchard.Group.prototype.getType = function() {
  return /** @type {!proto.loupe.common.orchard.SystemRoleType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.loupe.common.orchard.SystemRoleType} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional BasicStatus status = 5;
 * @return {!proto.loupe.common.orchard.BasicStatus}
 */
proto.loupe.common.orchard.Group.prototype.getStatus = function() {
  return /** @type {!proto.loupe.common.orchard.BasicStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.loupe.common.orchard.BasicStatus} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated string role_ids = 6;
 * @return {!Array<string>}
 */
proto.loupe.common.orchard.Group.prototype.getRoleIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setRoleIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.addRoleIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.clearRoleIdsList = function() {
  return this.setRoleIdsList([]);
};


/**
 * repeated SystemRole roles = 7;
 * @return {!Array<!proto.loupe.common.orchard.SystemRole>}
 */
proto.loupe.common.orchard.Group.prototype.getRolesList = function() {
  return /** @type{!Array<!proto.loupe.common.orchard.SystemRole>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_orchard_system_role_pb.SystemRole, 7));
};


/**
 * @param {!Array<!proto.loupe.common.orchard.SystemRole>} value
 * @return {!proto.loupe.common.orchard.Group} returns this
*/
proto.loupe.common.orchard.Group.prototype.setRolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.loupe.common.orchard.SystemRole=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.orchard.SystemRole}
 */
proto.loupe.common.orchard.Group.prototype.addRoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.loupe.common.orchard.SystemRole, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};


/**
 * repeated string crm_role_ids = 8;
 * @return {!Array<string>}
 */
proto.loupe.common.orchard.Group.prototype.getCrmRoleIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setCrmRoleIdsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.addCrmRoleIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.clearCrmRoleIdsList = function() {
  return this.setCrmRoleIdsList([]);
};


/**
 * repeated CRMRole crm_roles = 9;
 * @return {!Array<!proto.loupe.common.orchard.CRMRole>}
 */
proto.loupe.common.orchard.Group.prototype.getCrmRolesList = function() {
  return /** @type{!Array<!proto.loupe.common.orchard.CRMRole>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_orchard_crm_role_pb.CRMRole, 9));
};


/**
 * @param {!Array<!proto.loupe.common.orchard.CRMRole>} value
 * @return {!proto.loupe.common.orchard.Group} returns this
*/
proto.loupe.common.orchard.Group.prototype.setCrmRolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.loupe.common.orchard.CRMRole=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.orchard.CRMRole}
 */
proto.loupe.common.orchard.Group.prototype.addCrmRoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.loupe.common.orchard.CRMRole, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.clearCrmRolesList = function() {
  return this.setCrmRolesList([]);
};


/**
 * optional string parent_id = 10;
 * @return {string}
 */
proto.loupe.common.orchard.Group.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string group_path = 11;
 * @return {string}
 */
proto.loupe.common.orchard.Group.prototype.getGroupPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setGroupPath = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int32 order = 12;
 * @return {number}
 */
proto.loupe.common.orchard.Group.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string sync_filter = 13;
 * @return {string}
 */
proto.loupe.common.orchard.Group.prototype.getSyncFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setSyncFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string opportunity_filter = 14;
 * @return {string}
 */
proto.loupe.common.orchard.Group.prototype.getOpportunityFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setOpportunityFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.orchard.Group.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.orchard.Group} returns this
*/
proto.loupe.common.orchard.Group.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.orchard.Group.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string created_by = 16;
 * @return {string}
 */
proto.loupe.common.orchard.Group.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional google.protobuf.Timestamp updated_at = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.orchard.Group.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.orchard.Group} returns this
*/
proto.loupe.common.orchard.Group.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.orchard.Group.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string updated_by = 18;
 * @return {string}
 */
proto.loupe.common.orchard.Group.prototype.getUpdatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.orchard.Group} returns this
 */
proto.loupe.common.orchard.Group.prototype.setUpdatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


goog.object.extend(exports, proto.loupe.common.orchard);
